import { RpcBaseData } from '../rpc-base';

/**
 * RPC Overlay open command and version.
 */
export class RpcOverlayOpenKey {
    public static command = 'OverlayOpen';
    public static version = '0.1.0';
}

/**
 * RPC Overlay open command and version.
 */
export class RpcOverlayCloseKey {
    public static command = 'OverlayClose';
    public static version = '0.1.0';
}

/**
 * Rpc data for dialog overlay commands
 */
export interface RpcDialogOverlayData extends RpcBaseData {
    /**
     * Should overlay or not
     */
    overlay: boolean;
    /**
     * Id of the dialog
     */
    dialogId: string;
}

/**
 * Rpc result for dialog overlay outbound command
 */
export interface RpcDialogOverlayResult {
    /**
     * If module already handled overlay command from shell
     * true: No need to do anything
     * false: shell should remove the overlay by itself
     */
    overlayClosed: boolean;
}
